<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">
        <div class="col-12 mb-4">
            <v-alert v-if="!$store.getters.marchand && !$store.getters.isAdmin" style="background-color: #fff;padding-top:5px;padding-bottom:5px" outlined border="left" color="#29b3a6" type="success">{{$t('add_infos_params')}}</v-alert>
            <v-row>
                <v-col v-for="(bar, i) in bars" :key="i" cols="12" sm="12" md="12">
                    <v-card  color="grey lighten-4" flat >
                        <v-toolbar style="height: 100%" :color="bar.class" :dark="bar.dark">
                            <v-toolbar-title style="width: 100%; height: 100%;">
                                <div class="col-lg-12 col-xs-12 col-md-12" style="height: 100%;">
                                    <div class="row"  style="height: 100%;">
                                        <div class="col-xs-4 col-md-1  col-lg-1 col-4 mt-2" style="padding: 0 12px;height: 100%; ">
                                            <img class="img-profil" style="border-radius:100%" :src="user.image.cropped" alt="">
                                        </div>
                                        <div  class=" col-lg-11 col-md-11 col-xs-8  col-8 text-left pt-0" style="height: 100%">
                                            <div class="row" style="height: 100%;">
                                            <p class="user_name text-left col-lg-7 col-md-7 col-xs-8  col-8 pt-2">
                                                {{user._last_name}}
                                                <br>
                                                {{user._first_name}}  </p>
                                           <div   class="col-lg-5 col-md-5 col-xs-4  col-4  text-right ">
                                               <v-btn @click.prevent="logout"  icon>
                                                   <v-icon>mdi-power</v-icon>
                                               </v-btn>
                                           </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-toolbar-title>
                        </v-toolbar>
                    </v-card>
                </v-col>
            </v-row>

            <v-card v-if="!this.$store.getters.auth.role._code.toLowerCase().includes('admin')">

                <v-tabs  v-model="tabs" color="#1C3071" grow >
                    <v-tab  style="box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);transition: 0.3s; border-radius: 5px;">
                        <v-icon >mdi-account-circle-outline</v-icon>
                        <span style="margin-left: 5%"></span>
                          {{$t('menus.profil')}}
                    </v-tab>
                    <v-tab style="box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);transition: 0.3s; border-radius: 5px;">
                        <v-icon>mdi-information-outline</v-icon>
                        <span style="margin-left: 5%"></span>
                        {{$t('menus.information')}}
                    </v-tab>
                    <v-tab  style="box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);transition: 0.3s; border-radius: 5px;">
                        <v-icon>mdi-file-document-box </v-icon>
                        <span style="margin-left: 5%"></span>
                        {{$t('menus.documents')}}

                    </v-tab>
                    <v-tab style="box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);transition: 0.3s; border-radius: 5px;" v-if="$store.getters.marchand">
                        <v-icon>mdi-cog</v-icon>
                        <span style="margin-left: 5%"></span>
                          {{$t('menus.parametres')}}
                    </v-tab>

                </v-tabs>
                <v-tabs-items v-model="tabs">
                    <!--PROFIL-->
                    <v-tab-item>
                        <v-card flat>
                            <profil :pays="{_name:'Bénin',_value:'jijijjijij'}"></profil>
                        </v-card>
                    </v-tab-item>
                    <!--MARCAHND-->
                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <marchands/>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <!--DOCUMENTS-->
                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <marchand-document></marchand-document>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <ParamSetting ></ParamSetting>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>


                </v-tabs-items>

            </v-card>
            <v-card v-else>
                <v-tabs  v-model="tabs" color="#1C3071" grow >
                    <v-tab  style="box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);transition: 0.3s; border-radius: 5px;">
                        <v-icon >mdi-account</v-icon>
                        <span style="margin-left: 5%"></span>
                      {{$t('menus.profil')}}
                    </v-tab>
                    <v-tab style="box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);transition: 0.3s; border-radius: 5px;">
                        <v-icon>mdi-cog</v-icon>
                        <span style="margin-left: 5%"></span>
                        {{$t('menus.confirguration')}}
                    </v-tab>
                    <v-tab  style="box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);transition: 0.3s; border-radius: 5px;">
                        <v-icon>mdi-shield-lock </v-icon>
                        <span style="margin-left: 5%"></span>
                          {{$t('menus.securite')}}
                    </v-tab>
                    <v-tab  style="box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);transition: 0.3s; border-radius: 5px;">
                        <v-icon>mdi-bell</v-icon>
                        <span style="margin-left: 5%"></span>

                          {{$t('menus.notifications')}}
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tabs">
                    <!--PROFIL-->
                    <v-tab-item>
                        <v-card flat>
                            <profil :pays="{_name:'Bénin',_value:'jijijjijij'}"></profil>
                        </v-card>
                    </v-tab-item>
                    <!--PARAMETRE-->
                    <v-tab-item>
                        <v-card flat>
                            <GeneralSetting ></GeneralSetting>
                        </v-card>
                    </v-tab-item>
                    <!--SECURITE-->
                    <v-tab-item>
                        <v-card flat>

                        </v-card>
                    </v-tab-item>
                    <!--NOTIFICATION -->
                    <v-tab-item>
                        <v-card flat>
                            <NotificationSetting ></NotificationSetting>
                        </v-card>
                    </v-tab-item>

                </v-tabs-items>

            </v-card>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import Profil from "./components/settings/Profil";
    import GeneralSetting from "./components/settings/GeneralSetting";
    import MarchandDocument from "./components/settings/MarchandDocument";
    import NotificationSetting from "./components/settings/NotificationSetting";
    import ParamSetting from "./components/settings/ParamSetting";
    export default {
        name: "Reglages",
        components: {Profil,MarchandDocument,GeneralSetting,NotificationSetting,ParamSetting},

        data () {
            return {
                picker: new Date().toISOString().substr(0, 10),
                tabs: null,
                bars: [
                    { class: 'primary', dark: true },
                ],
                submitting:false,
                valid:true,
                lazy:false,
                errors:{},
                search: '',
                dialog: '',
                id:undefined,
                marchandexiste:false,
                headers: [

                ],
                editedIndex: -1,
                editedItem: {
                    _user_id: '',
                    _created_at: 0,
                    _id:''
                },

                defaultItem: {
                    _code: '',
                    _created_at: 0,
                    _id:''
                },

                codeRules: [
                    v => !!v || 'Code required',
                ],

            }
        },
        computed: {
            user : function(){
                return this.$store.getters.auth
            },

            formTitle () {
                return this.editedIndex === -1 ? this.$t('Nouveau compte marchand') : this.$t('Modifier information')
            },
            ...mapState('countries/', ['values']),
            ...mapState('countries/',['values']),
            ...mapState('marchands/',['marchand']),
            ...mapState('documents/',['document']),
            ...mapState('category_marchands/',['category_marchands']),


        },
        mounted(){
            if(this.$store.getters.marchand){this.marchandexiste=true}
           this.initialize();
        },
        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        methods: {
            categorieChanged(){
                this.categorieHasChanged = true;
            },
            newMarchand(){
              this.$router.push({ name: 'newAccountMarchand' })
            },

            initialize () {
                this.$store.dispatch('marchands/getMarchandOne').then(response => {
                    console.log('Marchand',response)
                });
                let marchand=this.marchand;
                this.$store.dispatch('documents/getDocumentOne',marchand._id).then(response => {
                    console.log('Mon document',response)
                    console.log('ID_MOMO',this.marchand)

                });
                this.$store.dispatch('category_marchands/getCategorie_Marchand').then(response => {
                    console.log('category_marchands',response)
                });
            },

            close () {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },

            validate () {
                this.$refs.form.validate()
            },
            reset () {
                this.$refs.form.reset()
            },
            checkisDashboard(){
                this.$emit('checkisDashboard',true);
            },
            fileChange() {
                console.log( this.$refs);
                this.editedItem._file = this.$refs.file.files[0];
            },
            getFileOriginalName(file){
                return file.substr(file.lastIndexOf('/')+1)
            },
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        },

    }
</script>

<style scoped>
    /* Helper classes */
    .basil {
        background-color: #FFFBE6 !important;
    }
    .basil--text {
        color: #356859 !important;
    }

</style>
